import { PostPartnerConfigType } from './types';

export const transformPostPartnerConfig = (
  requestData: PostPartnerConfigType
) => {
  // Inherit from the parent
  if (requestData.inheritParentInformation) {
    return {
      quote_pdf: {
        inherit_parent_information: true,
      },
      policy_access_level: requestData.policyAccessLevel,
    };
  }

  // Custom contact information
  if (requestData.customizeContactInformation) {
    return {
      quote_pdf: {
        inherit_parent_information: false,
        customize_contact_information: true,
        custom_contact_information: {
          agency_name: requestData.contactInformation.agencyName || null,
          agent_name: requestData.contactInformation.agentName || null,
          email_address: requestData.contactInformation.emailAddress || null,
          phone_number: requestData.contactInformation.phoneNumber || null,
        },
      },
      policy_access_level: requestData.policyAccessLevel,
    };
  }

  // If we do not have the other cases return Agent of Record
  return {
    quote_pdf: {
      inherit_parent_information: false,
      customize_contact_information: false,
    },
    policy_access_level: requestData.policyAccessLevel,
  };
};
